import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'split-agenda-modal-sidebar',
  templateUrl: './agenda-modal-sidebar.component.html',
  styleUrls: ['./agenda-modal-sidebar.component.scss']
})
export class AgendaModalSidebarComponent {
  @Input() sidebarVisible:boolean = false;
  @Output() close = new EventEmitter();

  form: FormGroup = this.fb.group({
    listaEspera: [''],
    unidade:[''],
    hora1: [''],
    hora:[''],
    frequencia: [''],
    programacao: [''],
    paciente:[''],
    pacienteBusca:[''],
    bairro: ['']
  });

  constructor(private fb: FormBuilder) {

  }

  toogleAgendamentosBtn(event: any) {}
  
  optionAgendamentosBtn: any =  [
    { label: 'Consulta', value: 'consulta' }, 
    { label: 'Bloqueio', value: 'bloqueio'}, 
    { label: 'Exceção', value: 'excecao'}
  ];

  pacientes: any[] | undefined;

  ngOnInit() {
      this.pacientes = [
          { name: 'Carlos', code: 'AU' },
          { name: 'Anastasia', code: 'BR' },
          { name: 'Rodrigo', code: 'CN' },
          { name: 'Felipe', code: 'EG' },
          { name: 'Tiago', code: 'FR' },
          { name: 'Yelizivieta krylova', code: 'DE' },
          { name: 'Gabriel', code: 'IN' },
          { name: 'Mateus', code: 'JP' },
          { name: 'Danilo', code: 'ES' },
          { name: 'Tiago', code: 'US' }
      ];
  }
  hide() {
    this.sidebarVisible = false;
    this.close.emit(true);
  }
}
